import { NeighbourAlarmsResponse } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

// No X-Data-Version here: event-flow does not support the header, so this
// endpoint is deliberately left version-agnostic.
export function useSharedNeighborAlarms(
  sharedToken: string,
  startTimestamp: number,
  endTimestamp: number
) {
  const host = window.location.hostname;
  const baseUrl =
    host === 'localhost'
      ? `http://${host}:${window.location.port}`
      : `https://event-flow-${host}`;

  const url = `${baseUrl}/shared/api/events/neighbors?sharedToken=${sharedToken}&startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;
  const request = new Request(url);

  return useAuthenticatedRequest<NeighbourAlarmsResponse>(request, {
    queryKey: ['shared', sharedToken, startTimestamp, endTimestamp],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    noAuth: true,
  });
}

export default useSharedNeighborAlarms;
